export default "__VITE_ASSET__FiFmNuxK__"